export class RoutingConstants {
  static POST_LOGIN_PATH = 'oauth/post-login';
  static LOGOUT_PATH = 'logout';
  static GRANT_PATH = 'grant';
  static TERMS_OF_SERVICE_PATH = 'terms-of-service';
}
